import employeeDropdownListComponent from './employeeDropdownList.component';

let employeeDropdownListModule = angular.module('vacations-absences.employeeDropdownList', [])

.component('employeeDropdownList', employeeDropdownListComponent)

.name;

export default employeeDropdownListModule;



// WEBPACK FOOTER //
// ./client/app/components/employeeDropdownList/employeeDropdownList.js